module.exports = __webpack_public_path__ + "img/07_Lichtwirkung@2x.189a3c9a.jpg";